// extracted by mini-css-extract-plugin
module.exports = {"confirmCardBtnContainer":"qQ","checkoutPrimaryButton":"rQ"};